// extracted by mini-css-extract-plugin
export default {"HeaderEditorContainer":"HeaderEditor-module__HeaderEditorContainer--cj48M"};